
import { useState } from 'react';

export default function Login({ supabase }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setError(error.message);
    setLoading(false);
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}><span style={styles.logoK}>K</span><span style={styles.logoText}>argoSL</span></div>
        <p style={styles.subtitle}>Admin Dashboard</p>
        <p style={styles.desc}>Sierra Leone Operations Center</p>
        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>Email Address</label>
            <input style={styles.input} type="email" placeholder="admin@kargosl.com" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input style={styles.input} type="password" placeholder="Enter your password" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          {error && <p style={styles.error}>{error}</p>}
          <button style={styles.button} type="submit" disabled={loading}>{loading ? 'Signing in...' : 'Sign In to Admin'}</button>
        </form>
        <p style={styles.footer}>KargoSL Admin • Authorized Access Only</p>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif' },
  card: { background: '#111', border: '1px solid #222', borderRadius: 16, padding: 48, width: '100%', maxWidth: 420, textAlign: 'center' },
  logo: { fontSize: 48, fontWeight: 'bold', marginBottom: 8 },
  logoK: { color: '#00A651' },
  logoText: { color: '#fff' },
  subtitle: { color: '#fff', fontSize: 18, fontWeight: '600', margin: '4px 0' },
  desc: { color: '#666', fontSize: 14, marginBottom: 32 },
  form: { textAlign: 'left' },
  field: { marginBottom: 20 },
  label: { display: 'block', color: '#999', fontSize: 13, fontWeight: '600', marginBottom: 6 },
  input: { width: '100%', background: '#1a1a1a', border: '1px solid #333', borderRadius: 8, padding: '12px 16px', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box' },
  error: { color: '#e74c3c', fontSize: 13, marginBottom: 16 },
  button: { width: '100%', background: '#00A651', color: '#fff', border: 'none', borderRadius: 8, padding: '14px', fontSize: 16, fontWeight: 'bold', cursor: 'pointer', marginTop: 8 },
  footer: { color: '#444', fontSize: 12, marginTop: 32 },
};
